export const STAFF_SORTING_METHODS = [
  {
    name: 'Random (Default)',
    value: 'RANDOM',
  },
  {
    name: 'Alphabetical (A–Z)',
    value: 'ALPHABETICAL',
  },
];
